import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 26, className = "", ...rest }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.12 }}
    transition={{ duration: 0.7, delay, ease: [0.2, 0.7, 0.2, 1] }}
    {...rest}
  >
    {children}
  </motion.div>
);
